import React from "react";

/* One tab throwing must never blank the whole customer popup. Each tab's body
   renders inside this boundary, so a bad payload (or an object rendered as a
   React child) degrades to an inline "this tab couldn't load — retry" with the
   real error text, while the header, tab bar, footer and every other tab stay
   usable. `tabKey` resets the boundary when the active tab changes, so moving
   to a healthy tab always clears a previous tab's error. */
export default class PopupTabBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { failed: false, msg: "" };
  }

  static getDerivedStateFromError(error) {
    return { failed: true, msg: (error && (error.message || String(error))) || "Unexpected error." };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error(`[CustomerPopup] tab "${this.props.tabKey}" render failed:`, error, info?.componentStack);
  }

  componentDidUpdate(prev) {
    // A different tab is a fresh surface — clear a prior failure.
    if (prev.tabKey !== this.props.tabKey && this.state.failed) {
      this.setState({ failed: false, msg: "" });
    }
  }

  render() {
    if (this.state.failed) {
      return (
        <div className="cp-tab-error" role="alert">
          <div className="cp-tab-error__title">This tab couldn’t load.</div>
          {this.state.msg ? <div className="cp-tab-error__msg">{this.state.msg}</div> : null}
          <button
            type="button"
            className="cp-btn cp-btn--ghost"
            onClick={() => this.setState({ failed: false, msg: "" })}
          >
            Retry
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
